<template>
	<aside class="main-sidebar">
		<!-- sidebar: style can be found in sidebar.less -->
		<section class="sidebar">
			<!-- Sidebar Menu -->
			<sidebar-menu />
			<!-- /.sidebar-menu -->
		</section>
		<!-- /.sidebar -->
	</aside>
</template>

<script>
import SidebarMenu from './SidebarMenu';

export default {
	name: 'Sidebar',
	props: ['displayName', 'pictureUrl'],
	components: { SidebarMenu },
	mounted: function() {
		window
		.jQuery('[data-toggle="hideseek"]')
		.off()
		.hideseek();
	},
};
</script>


// WEBPACK FOOTER //
// Sidebar.vue?6c6c062a